<template>
<w-sliding-popup ref="rootCauseAnalysisPopup" :title="title" width="1200px" @close="close">
  <div slot="content">
    <el-row class="title-bar mr-t10" type="flex" justify="space-between" style="height:31px">
      <div class="vertical-center-box">
        <div class="title-h4">핵심 장애 정보</div>
      </div>
    </el-row>
    <div class="mr-b25">
      <el-row class="list form-list mr-b10">
        <el-col :span="12" class="pd-r20">
          <el-form label-position="left">
            <el-form-item label="장애대상" label-width="120px">{{eventHistFormData.objName}}</el-form-item>
            <el-form-item label="관리구분" label-width="120px">{{eventHistFormData.managetypeName}}</el-form-item>
            <el-form-item label="이벤트 등급" label-width="120px">{{eventHistFormData.eventlevelName}}</el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form size="mini" label-position="left">
            <el-form-item label="IP 주소" label-width="120px">{{eventHistFormData.ipaddress}}</el-form-item>
            <el-form-item label="자원구분" label-width="120px">{{eventHistFormData.rsctypeName}}</el-form-item>
            <el-form-item label="이벤트 발생 시각" label-width="120px">{{getDateToString(eventHistFormData.checkDatetime)}}</el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-input readonly resize="none" type="textarea" v-model="eventHistFormData.eventMessage" :rows="3" class="ticket-input-class"></el-input>
    </div>
    <el-row v-if="eventHistData.rootCauseFlag === 'E'" :gutter="14">
      <el-col :span="6">
        <w-root-cause-tree ref="rootCauseTree" :obj-id="eventHistData.objId" @set-node-data="setNodeData" />
      </el-col>
      <el-col :span="18">
        <w-root-cause-event-table ref="rootCauseEventTable" :event-hist-data="eventHistData" :node-data="selectedNodeData" />
      </el-col>
    </el-row>
    <el-row v-else-if="eventHistData.rootCauseFlag === 'A'">
      <w-root-cause-alarm-table ref="rootCauseEventTable" :event-hist-data="eventHistData" />
    </el-row>
  </div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import WRootCauseTree from './components/RootCauseTree';
import WRootCauseEventTable from './components/RootCauseEventTable';
import WRootCauseAlarmTable from './components/RootCauseAlarmTable';

export default {
  name: 'WEventrootCauseAnalysisPopup',
  components: {
    WRootCauseTree,
    WRootCauseEventTable,
    WRootCauseAlarmTable,
  },
  data() {
    return {
      eventHistData: {},
      eventHistFormData: {},
      selectedNodeData: {},
    };
  },
  computed: {
    title() {
      if (!isEmpty(this.eventHistData)) {
        return `${this.eventHistData.objName} - ${this.eventHistData.eventMessage}`;
      }
      return '';
    },
  },
  watch: {
    eventHistData: {
      handler(value) {
        if (isEmpty(value)) {
          this.eventHistFormData = {};
        } else {
          this.eventHistFormData = {
            ...value,
          };
        }
      },
    },
  },
  methods: {
    isNil,
    getValueAfterCheckEmpty,
    open(data) {
      this.eventHistData = data;
      this.$refs.rootCauseAnalysisPopup.open();
    },
    close() {
      this.eventHistData = {};
    },
    setNodeData(nodeData) {
      this.selectedNodeData = nodeData;
    },
    /**
     * 날짜 데이터를 문자열 형태로 변환한다.
     * @author Ju
     * @param  {Date} value
     */
    getDateToString(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/popup/RootCauseAnalysisPopup/index.vue